import React, { useState } from 'react';
import { USER_PROFILE_UPDATE } from '../Utils/apis';

const useProfileUpdator = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fn = async (data) => {
        if (!loading) {
            const payload = {
                first_name: data.firstName,
                last_name: data.lastName,
                gender: data.gender,
                mobile: data.mobile,
                designation: data.designation,
                location: data.location,
                city: data.city,
                education: data.education,
                years_of_experience: Number(data.years_of_experience),
                country: data.country,
                handles: {
                    Github: data.handles?.Github || '',
                    Linkedin: data.handles?.Linkedin || data.linkedin || '',
                    Twitter: data.handles?.Twitter || '',
                    Other_Handles: data.handles?.Other_Handles || '',
                },
                preffered_job_types: data.interest ?? [],
                current_ctc:
                    data.current_ctc !== undefined && data.current_ctc !== null
                        ? Number(data.current_ctc)
                        : undefined,
                expected_ctc:
                    data.expected_ctc !== undefined && data.expected_ctc !== null
                        ? Number(data.expected_ctc)
                        : undefined,
                job_industry: data.jobIndustry ?? data.job_industry,
                profile_url: data.profileUrl ?? data.profile_url,
                resume_url: data.cvUrl ?? data.resume_url,
                open_to_work: data.open_to_work,
                disc_status: data.disc_status,
                disc_summary: data.disc_summary,
            };

            try {
                setLoading(true);
                const res = await fetch(`${USER_PROFILE_UPDATE}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                });

                if (!res.ok) {
                    const err = await res.json();
                    throw new Error(err.error);
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        }
    };

    return [loading, error, fn];
};

export default useProfileUpdator;